export default {
  facebook: 'フェイスブック',
  twitter: 'ツイッター',
  github: 'Github',
  linkedin: 'LinkedIn',
  google: 'グーグルプラス'
}
